import { useEffect, useRef, useState } from 'react';
import { useApiaComponentContext } from '../../apiaComponent/ApiaComponentContext';
import TreeDataController from '../../../../common/generic/tree/TreeDataController';
import { TUseTreeApi } from './types';
import ApiaTreeApi from './ApiaTreeApi';

const apiaTreeApisContainer: Record<string, ApiaTreeApi> = {};

export function getApiaTreeApi(id: string) {
  return apiaTreeApisContainer[id];
}

export function deleteApiaTreeApi(id: string) {
  const api = apiaTreeApisContainer[id];
  delete apiaTreeApisContainer[id];
  api?.destroy();
}

export function setApiaTreeApi(id: string, api: ApiaTreeApi) {
  apiaTreeApisContainer[id]?.destroy();
  apiaTreeApisContainer[id] = api;
}

export default function useTreeApi(): TUseTreeApi {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handler = useRef<TreeDataController<any> | null>(null);
  const api = useRef<ApiaTreeApi | null>(null);

  const [state, setState] = useState<TUseTreeApi>({
    getHandler(newHandler) {
      handler.current = newHandler;
      api.current?.updateHandler(newHandler);
    },
  });

  const { fieldId } = useApiaComponentContext();

  useEffect(() => {
    api.current = new ApiaTreeApi(
      fieldId,
      handler.current as TreeDataController,
    );

    api.current.onStateUpdate((newState) => {
      setState((currentState) => ({ ...currentState, ...newState }));
    });

    return () => {
      api.current?.destroy();
      api.current = null;
    };
  }, [fieldId]);

  return state;
}
